import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { BaseDialog } from 'components'
import useStyles from './styles'
import { WarningRounded } from '@material-ui/icons'

const AcceptanceCollect = ({ open, setOpen, onSubmit }) => {
  const classes = useStyles()

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Disparar coleta de aceites"
      closeButtonText="Agora não"
      actionButtonText="Disparar assinaturas"
      actionButton={onSubmit}
      justifyActions="flex-end"
      dialogSize="md"
    >
      <Typography variant="body1" className={classes.warningTitle}>
        <WarningRounded /> ATENÇÃO:
      </Typography>
      <Box className={classes.cardInfo} mb={2}>
        <Typography variant="body1">
          Este documento tem <strong>coleta de assinaturas vinculada</strong>.
          Deseja <strong>reenviar os e-mails</strong> de assinaturas para a nova
          versão?
        </Typography>
      </Box>
    </BaseDialog>
  )
}

AcceptanceCollect.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default AcceptanceCollect
